"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlatform = exports.PlatformProvider = void 0;
var Platform_1 = require("./Platform");
Object.defineProperty(exports, "PlatformProvider", { enumerable: true, get: function () { return Platform_1.PlatformProvider; } });
Object.defineProperty(exports, "usePlatform", { enumerable: true, get: function () { return Platform_1.usePlatform; } });
